// src/pages/appointments/AppointmentsFiltersContext.jsx //
import React from "react";

const Ctx = React.createContext(null);

/**
 * Sheet modes we support
 * - main: main filter list
 * - specialty: specialty picker
 * - language: language picker
 * - date: date picker
 */
const DEFAULT_MODE = "main";

export function AppointmentsFiltersProvider({ children }) {
  // ✅ SSOT for filters across ALL /appointments/* routes
  const [filters, setFilters] = React.useState({
    data: [], // ids: best-rating, near-you, verified, evisit
    specialty: [], // array of specialty strings
    payment: [], // array of ids (future)
    language: [], // array of language strings
    date: null, // ISO YYYY-MM-DD
  });

  // ✅ bottom sheet state (SSOT)
  const [isFilterOpen, setIsFilterOpen] = React.useState(false);
  const [sheetMode, setSheetMode] = React.useState(DEFAULT_MODE);

  const openSheet = React.useCallback((mode = DEFAULT_MODE) => {
    setSheetMode(mode);
    setIsFilterOpen(true);
  }, []);

  const closeSheet = React.useCallback(() => {
    setIsFilterOpen(false);
    setSheetMode(DEFAULT_MODE);
  }, []);

  // ✅ booking selection (SSOT)
  const [selectedDate, setSelectedDate] = React.useState(null); // ISO YYYY-MM-DD
  const [selectedTime, setSelectedTime] = React.useState(null); // "09:30" etc

  const clearBooking = React.useCallback(() => {
    setSelectedDate(null);
    setSelectedTime(null);
  }, []);

  const value = React.useMemo(
    () => ({
      filters,
      setFilters,

      isFilterOpen,
      setIsFilterOpen,
      sheetMode,
      setSheetMode,
      openSheet,
      closeSheet,

      selectedDate,
      setSelectedDate,
      selectedTime,
      setSelectedTime,
      clearBooking,
    }),
    [
      filters,
      isFilterOpen,
      sheetMode,
      openSheet,
      closeSheet,
      selectedDate,
      selectedTime,
      clearBooking,
    ]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useAppointmentsFilters() {
  const v = React.useContext(Ctx);
  if (!v) {
    throw new Error("useAppointmentsFilters must be used within AppointmentsFiltersProvider");
  }
  return v;
}
